import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLeadCardFields as GetLeadCardFieldsQuery,
    GetLeadCardFields_leadCardFields as LeadCardField,
} from 'nutshell-graphql-types';

import GET_LEAD_CARD_FIELDS from '../queries/get-lead-card-fields.graphql';

type Return = {
    isLoading: boolean;
    leadCardFields: LeadCardField[];
    errorMessage: string | null | undefined;
    refetchFields: () => Promise<any>;
};

export const useGetLeadCardFields = (stagesetId?: string | null): Return => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetLeadCardFieldsQuery, Record<any, any>>(GET_LEAD_CARD_FIELDS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            stagesetId,
        },
        skip: !stagesetId,
    });

    const leadCardFields = data ? data.leadCardFields : null;

    return {
        isLoading,
        leadCardFields: leadCardFields || [],
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetchFields: refetch,
    };
};
